// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});
document.querySelectorAll('.eyely-category-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    
    // Remove active from all buttons
    document.querySelectorAll('.eyely-category-btn')
      .forEach(b => b.classList.remove('active'));

    // Add active to clicked button
    this.classList.add('active');

    // 👉 Auto scroll left sidebar
    this.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Panel switching
    const categoryName = this.dataset.categoryId;
    const targetPanelId = categoryName;

    document.querySelectorAll('.submenus-wrapper')
      .forEach(panel => panel.classList.remove('active'));

    const targetPanel = document.getElementById(targetPanelId);
    if (targetPanel) {
      targetPanel.classList.add('active');
    }

    // 👉 Auto scroll RIGHT panel to top
    const contentArea = document.getElementById('content-area');
    if (contentArea) {
      contentArea.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  });
});
let syncing = false;

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
const variant = evt.detail.variant;

  if(!variant) return;
  
  var dimensions=document.querySelector(".prd-width-table");
  if(dimensions &&  evt.detail.variant){
    document.querySelectorAll(".size-info-ext").forEach(item => {
    item.classList.remove("active");
    });
      var current_row=document.getElementById("ext-"+variant.id);
      current_row.classList.add("active");
        // var allRowsNew = document.querySelectorAll(".variant-info-row");
        // allRowsNew.forEach((row) => {
        //   row.classList.remove("active");
        // });
        var extIdNew = ".info-" + evt.detail.variant.id;
        var activeRowSelected = document.querySelectorAll(extIdNew);
        activeRowSelected.forEach((row) => {
          row.classList.add("active");
        });
  }
  if(!variant) return;

  if(document.querySelector(".image-wrapper-dimension")){
      var allRowsImages = document.querySelectorAll(".image-wrapper-dimension");
        allRowsImages.forEach((row) => {
          row.classList.remove("active");
        });
        let extId = "img-" + evt.detail.variant.id;
        let activeRowImage = document.getElementById(extId);
        if (activeRowImage) {
          activeRowImage.classList.add("active");
        }
        
  }

  if(!variant) return;

  const notifyMain = document.querySelector(".notify-main");
  if (notifyMain && evt.detail.variant) {
    if (evt.detail.variant.available == false) {
      document.querySelector(".notify-main").style.display = "block";
    } else {
      document.querySelector(".notify-main").style.display = "none";
    }
  }
  if(!variant) return;
  if(document.querySelector(".join-product-contents")){
  if (!variant || syncing) return;  
  
  syncing = true;

  const basinVariantTitle = variant.title; // Get the selected variant title for Basin
  const basinProduct = window.shopifyProductData; // Fetch product data (ensure this is available in your JS)      
  const associatedSinkVariantId = basinProduct.variants.find(v => v.id === variant.id)?.metafields.custom.bundle_variant.value;    
    // Get the select elements for Basin and Sink variants
    const basinSelect = document.querySelector('#variant-selector');
    const sinkSelect = document.querySelector('#sink-selector');
  // If associated Sink variant ID is available
    if (associatedSinkVariantId) {
      // Find the corresponding Sink variant option
      const sinkOption = sinkSelect.querySelector(`option[value="${associatedSinkVariantId}"]`);
      if (sinkOption) {
        sinkOption.selected = true;  // Select the corresponding Sink option
        sinkSelect.dispatchEvent(new Event('change')); // Trigger change event for Sink select
      const sinkVariant = sinkOption.dataset.variant.split(' / ');
      const sinkColor = sinkVariant[0];
      const sinkSize = sinkVariant[1];

      const sinkColorSwatch = document.querySelector(
        `[data-product-option="option1"] .dynamic-variant-button-new[data-option-value="${sinkColor}"]`
      );

      const sinkSizeSwatch = document.querySelector(
        `[data-product-option="option2"] .dynamic-variant-button-new[data-option-value="${sinkSize}"]`
      );

      const parentGroup = sinkColorSwatch.closest('[data-option-buttons-new]'); // current option group
      const groupSwatches = parentGroup.querySelectorAll('.dynamic-variant-button-new');
      groupSwatches.forEach(s => s.classList.remove('selected-new'));

      sinkColorSwatch.classList.add("selected-new");
      const parentOption1 = sinkColorSwatch.closest('.product__option');
      const selectedLabel1 = parentOption1.querySelector('[data-selected-value-for-option]');
      if (selectedLabel1) {
        selectedLabel1.textContent = sinkColor;
      }
      const parentGroup2 = sinkSizeSwatch.closest('[data-option-buttons-new]'); // current option group
      const groupSwatches2 = parentGroup2.querySelectorAll('.dynamic-variant-button-new');
      groupSwatches2.forEach(s => s.classList.remove('selected-new'));
      sinkSizeSwatch.classList.add("selected-new");
      const parentOption = sinkSizeSwatch.closest('.product__option');
      const selectedLabel = parentOption.querySelector('[data-selected-value-for-option]');
      if (selectedLabel) {
        selectedLabel.textContent = sinkSize;
      }
      updateTotalPrice();
      updateSinkSwatches();
      syncing = false;

      }
    }
  }
  
  if(!variant) return;
 const rugSize = variant.option3;
  if (!rugSize) return;
  const normalizedSize = normalizeRugSize(rugSize);
  document.querySelectorAll(".upsell-item").forEach(item => {

    const select = item.querySelector(".upsell-select");
    const checkbox = item.querySelector(".rug-upsell");
    const priceEl = item.querySelector(".upsell-price");

    if (!select) return;

    let matchedOption = null;

    select.querySelectorAll("option").forEach(option => {

      if (option.dataset.sizeLabel === normalizedSize) {
        matchedOption = option;
      }

    });

    if (!matchedOption) return;

    const available = matchedOption.dataset.available === "true";

    if (available) {

      select.value = matchedOption.value;

      // update price
      const price = matchedOption.dataset.priceAddon;
          window.theme = window.theme || {}; // Ensure window.theme exists

      if (priceEl) {
      priceEl.innerHTML = window.theme.formatMoney(price);
      }

      // enable upsell
      checkbox.disabled = false;

    } else {

      // disable upsell if size not available
      checkbox.checked = false;
      checkbox.disabled = true;

      if (priceEl) {
        priceEl.innerHTML = "SOLDOUT";
      }

    }

  });

});
const basinSelect = document.getElementById('variant-selector');
const sinkSelector = document.getElementById('sink-selector');
if(sinkSelector){
function updateTotalPrice() {
  const basinSelect = document.querySelector('#variant-selector');
  const sinkSelect = document.querySelector('#sink-selector');
  const basinOption = basinSelect.options[basinSelect.selectedIndex];
  const sinkOption = sinkSelect.options[sinkSelect.selectedIndex];
  const basinPrice = parseFloat(basinOption.dataset.op || 0);
  const sinkPrice = parseFloat(sinkOption.dataset.p || 0);
  const totalPrice = basinPrice + sinkPrice;
  const priceContainer = document.querySelector('.product__price [data-price]');
  if (priceContainer) {
    priceContainer.textContent = window.theme.formatMoney(totalPrice);
  }
}
updateTotalPrice();

// Sync Sink variant changes back to Basin
  document.querySelector('#sink-selector').addEventListener('change', function (e) {   
  if (syncing) return;
  syncing = true;
    const selectedSinkVariantId = e.target.value; // Get selected Sink variant ID
    // Find the corresponding Basin variant based on Sink variant ID (from bundle_variant)
    const basinProduct = window.shopifyProductData; // Fetch product data (ensure this is available in your JS)
    const associatedSinkVariantId = basinProduct.variants.find(v => v.metafields.custom.bundle_variant.value === selectedSinkVariantId)?.id;

    // If the Sink variant matches, update the corresponding Basin variant
    if (associatedSinkVariantId) {
      const correspondingBasinVariant = basinProduct.variants.find(v => v.id === associatedSinkVariantId);
      const basinOption = basinSelect.querySelector(`option[value="${correspondingBasinVariant.id}"]`);
      if (basinOption) {
        basinOption.selected = true;
        basinSelect.dispatchEvent(new Event('change')); // Trigger change event for Basin select      
        const basinVariant = basinOption.dataset.variant.split(' / ');
       const basinColor = basinVariant[0];
       const basinSize = basinVariant[1];
       const basinColorSwatch = document.querySelector(
         `[data-product-option="option1"] .dynamic-variant-button[data-option-value="${basinColor}"]`
       );
       const basinSizeSwatch = document.querySelector(
         `[data-product-option="option2"] .dynamic-variant-button[data-option-value="${basinSize}"]`
       );
       basinColorSwatch?.click();
       basinSizeSwatch?.click();
         syncing = false;

      }
    }
       updateSinkSwatches();


   });
  // Get all new swatches
  const swatches = document.querySelectorAll('.dynamic-variant-button-new');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      const parentGroup = swatch.closest('[data-option-buttons-new]'); // current option group
      const groupSwatches = parentGroup.querySelectorAll('.dynamic-variant-button-new');
      groupSwatches.forEach(s => s.classList.remove('selected-new'));
      swatch.classList.add('selected-new');
      const optionValue = swatch.getAttribute('data-option-value');
      const parentOption = swatch.closest('.product__option');

      const selectedLabel = parentOption.querySelector('[data-selected-value-for-option]');
      if (selectedLabel) {
        selectedLabel.textContent = optionValue;
      }
      let optionToSelect = Array.from(sinkSelector.options).find(opt => opt.dataset.option1 === optionValue);
      if (optionToSelect) {
        sinkSelector.value = optionToSelect.value;
        const event = new Event('change', { bubbles: true });
        sinkSelector.dispatchEvent(event);
      }else{
       optionToSelect = Array.from(sinkSelector.options).find(opt => opt.dataset.option2 === optionValue);
       sinkSelector.value = optionToSelect.value;
        const event = new Event('change', { bubbles: true });
        sinkSelector.dispatchEvent(event);
      }
       const swatchColor = swatch.closest('[data-product-option="option1"]') ? swatch.getAttribute('data-option-value') : null;
       const swatchSize = swatch.closest('[data-product-option="option2"]') ? swatch.getAttribute('data-option-value') : null;
       const matchingSinkOption = Array.from(sinkSelector.options).find(opt => 
        (!swatchColor || opt.dataset.option1 === swatchColor) &&
        (!swatchSize || opt.dataset.option2 === swatchSize)
      );

        if (matchingSinkOption) {
          const sinkTitle = matchingSinkOption.dataset.variant; // this is the basin variant title we need to select
          const basinOption = Array.from(basinSelect.options).find(opt => opt.dataset.variant === sinkTitle);
          if (basinOption) {
            basinSelect.value = basinOption.value;
            basinSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });

    function updateSinkSwatches() {
          const selectedColor = document.querySelector('[data-option-buttons-new][data-product-option="option1"] .selected-new')?.getAttribute('data-option-value');
          const selectedSize = document.querySelector('[data-option-buttons-new][data-product-option="option2"] .selected-new')?.getAttribute('data-option-value');

          swatches.forEach(swatch => {
            // Determine which value this swatch represents
            const swatchGroup = swatch.closest('[data-option-buttons-new]').dataset.productOption;
            let swatchColor = swatchGroup === 'option1' ? swatch.getAttribute('data-option-value') : selectedColor;
            let swatchSize = swatchGroup === 'option2' ? swatch.getAttribute('data-option-value') : selectedSize;

            // Find matching option in sink-selector
            const matchingOption = Array.from(sinkSelector.options).find(opt =>
              opt.dataset.option1 === swatchColor && opt.dataset.option2 === swatchSize
            );

            // Reset classes
            swatch.classList.remove('available', 'sold-out', 'unavailable');
console.log("matchingOption.dataset.availabl",matchingOption.dataset.available);
            if (!matchingOption) {
              swatch.classList.add('unavailable'); // No such variant
            } else if (matchingOption.dataset.available !== "true") {
              swatch.classList.add('sold-out'); // Variant exists but not available
            } else {
              swatch.classList.add('available'); // Variant exists and is available
            }      
      });
  }
updateSinkSwatches();
}

function normalizeRugSize(size){

  size = size.toLowerCase().replace(/-/g,'').replace(/"/g,'').trim();

  const parts = size.split("x");

  if(parts.length !== 2) return null;

  let w = convertToFeet(parts[0]);
  let h = convertToFeet(parts[1]);

  const standardSizes = [
    [2,8],
    [2,10],
    [3,5],
    [4,6],
    [5,8],
    [6,9],
    [8,10],
    [9,12],
    [10,14],
    [12,15],
    [12,18]
  ];

  let closest = null;
  let smallestDiff = Infinity;

  standardSizes.forEach(s => {

    const diff = Math.abs(w - s[0]) + Math.abs(h - s[1]);

    if(diff < smallestDiff){
      smallestDiff = diff;
      closest = s;
    }

  });

  return closest[0] + " X " + closest[1];
}



function convertToFeet(value){

  value = value.trim();

  let feet = 0;
  let inches = 0;

  const feetMatch = value.match(/(\d+)'/);
  const inchMatch = value.match(/(\d+)$/);

  if(feetMatch) feet = parseInt(feetMatch[1]);
  if(inchMatch && value.includes("'")) inches = parseInt(inchMatch[1]);

  return feet + (inches/12);

}
// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
const element = document.getElementById("notify_button");

if (element) {
  element.addEventListener("click", function () {

    const email = document.getElementById("notify_email").value;
    const vid = parseInt(document.getElementById("variant-selector").value);

    console.log(email);
    console.log(vid);

    fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: new URLSearchParams({
        a: "NxHZVf",
        email: email,
        variant: vid,
        platform: "shopify"
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
    })
    .catch(error => {
      console.log(error);
    });

    document.querySelector(".notify-main").style.display = "none";
    document.querySelector(".thank-msg").style.display = "block";
  });
}